jQuery(document).ready(function($) {
	
	/* Main History - BEGIN */
		var mainHistory = $(".main-history .listing");

		mainHistory.addClass("owl-carousel").owlCarousel({
			items: 1,
			margin: 0,
			dots: false,
			loop: false,
			autoplay: false,
			autoHeight: true,
			onInitialized: function(e){ mainHistory_arrows(e); },
			onChanged: function(e){ mainHistory_arrows(e); },
		});

		$(".main-history").on('click', '#main-history-prev', function(event) {
			mainHistory.trigger('prev.owl.carousel');
		});

		$(".main-history").on('click', '#main-history-next', function(event) {
			mainHistory.trigger('next.owl.carousel');
		});

		function mainHistory_arrows(event){
			/**/
			if(event.item.index == 0){ $("#main-history-prev").hide(); }else{ $("#main-history-prev").show(); }

			/**/
			if(event.item.index == (event.item.count - 1)){ $("#main-history-next").hide(); }else{ $("#main-history-next").show(); }
		}
	/* Main History - END */
	
});